export default {"src":"/_next/static/image/src/images/pup-sparkles-box.df2e9c6417680884525ea0505089c617.svg","height":82,"width":114};